export type LocaleDictionary = Record<string, string>;

export enum LocaleProject {
  USER_SITE_FRONT = 'user-site-front',
  PROMOCODES = 'promocodes',
  GIFTCARDS = 'giftcards',
  HOME_USER_SITE_FRONT = 'home-user-site-front',
}
